'use strict';

var React = require('react');

var SvgAutomationFilledIcon = function SvgAutomationFilledIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 4.176c0-.76.617-1.376 1.377-1.376h1.246c.76 0 1.376.616 1.376 1.376v.688c0 .19.126.396.358.517.146.076.287.159.424.248.221.144.465.152.632.056l.6-.347c.658-.38 1.5-.154 1.88.504l.622 1.08c.38.658.155 1.5-.503 1.88l-.648.373c-.163.094-.277.303-.269.56l.002.909v.41l-.35-.243a1.75 1.75 0 0 0-2.747 1.439v3.501c0 .76-.617 1.376-1.377 1.376h-1.246c-.76 0-1.376-.616-1.376-1.376v-.81c0-.192-.127-.397-.359-.518a5.104 5.104 0 0 1-.333-.19c-.22-.138-.458-.143-.621-.049l-.7.405c-.659.38-1.5.154-1.88-.504l-.624-1.08a1.375 1.375 0 0 1 .504-1.879l.653-.377c.167-.097.282-.311.268-.575a5.175 5.175 0 0 1-.004-.439c.008-.257-.106-.465-.27-.56l-.647-.374a1.376 1.376 0 0 1-.504-1.88l.624-1.079a1.376 1.376 0 0 1 1.88-.504l.6.347c.166.096.41.088.631-.056.137-.09.278-.172.423-.248.232-.121.359-.326.359-.517v-.688Zm2 7.324a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.035 11.839 3.25 2.25a.5.5 0 0 1 0 .822l-3.25 2.25a.5.5 0 0 1-.785-.411v-4.5a.5.5 0 0 1 .785-.411Z"
  }));
};
SvgAutomationFilledIcon.displayName = "AutomationFilledIcon";

exports.SvgAutomationFilledIcon = SvgAutomationFilledIcon;
